var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgExclamationMark = function SvgExclamationMark(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.97644V15.5059",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 21.5293C14.8317 21.5293 15.5059 20.8551 15.5059 20.0235C15.5059 19.1918 14.8317 18.5176 14 18.5176C13.1683 18.5176 12.4941 19.1918 12.4941 20.0235C12.4941 20.8551 13.1683 21.5293 14 21.5293Z",
    fill: "#054BC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0002 26.8C21.0694 26.8 26.8002 21.0692 26.8002 14C26.8002 6.93071 21.0694 1.19995 14.0002 1.19995C6.93095 1.19995 1.2002 6.93071 1.2002 14C1.2002 21.0692 6.93095 26.8 14.0002 26.8Z",
    stroke: "#054BC7",
    strokeWidth: 1.5
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationMark);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDcuOTc2NDRWMTUuNTA1OSIgc3Ryb2tlPSIjMDU0QkM3IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQgMjEuNTI5M0MxNC44MzE3IDIxLjUyOTMgMTUuNTA1OSAyMC44NTUxIDE1LjUwNTkgMjAuMDIzNUMxNS41MDU5IDE5LjE5MTggMTQuODMxNyAxOC41MTc2IDE0IDE4LjUxNzZDMTMuMTY4MyAxOC41MTc2IDEyLjQ5NDEgMTkuMTkxOCAxMi40OTQxIDIwLjAyMzVDMTIuNDk0MSAyMC44NTUxIDEzLjE2ODMgMjEuNTI5MyAxNCAyMS41MjkzWiIgZmlsbD0iIzA1NEJDNyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjAwMDIgMjYuOEMyMS4wNjk0IDI2LjggMjYuODAwMiAyMS4wNjkyIDI2LjgwMDIgMTRDMjYuODAwMiA2LjkzMDcxIDIxLjA2OTQgMS4xOTk5NSAxNC4wMDAyIDEuMTk5OTVDNi45MzA5NSAxLjE5OTk1IDEuMjAwMiA2LjkzMDcxIDEuMjAwMiAxNEMxLjIwMDIgMjEuMDY5MiA2LjkzMDk1IDI2LjggMTQuMDAwMiAyNi44WiIgc3Ryb2tlPSIjMDU0QkM3IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K";